/**
 * These endpoints should be all relative to Vignette origin URL, i.e:
 *   - http://localhost:8080/ => redirects will be broken in most cases
 *   - http://localhost:8001/vignette/
 *   - https://dev.njdc.com/vignette/
 *   - https://www.nationaljournal.com/vignette/
 */
/* eslint typescript-sort-keys/string-enum: "error" */
export enum VignetteEndpoints {
  API_ADD_ALL_SEARCH_RESULTS = "api/briefcase/addAllSearchResults/",
  API_APP_CONFIG = "api/config/app/",
  API_BRIEFCASE = "api/briefcase/",
  API_BRIEFCASE_DOWNLOAD_CHECK = "api/folderDossierDownloadCheck/",
  API_BRIEFCASE_FOLDER_ADD = "api/briefcase/folder/add",
  API_BRIEFCASE_FOLDER_DELETE = "api/briefcase/folder/delete",
  API_BRIEFCASE_TOGGLE = "api/briefcase/toggle/",
  API_EMAIL_VALIDATION = "api/emailValidation/",
  API_HOMEPAGE_CONFIG = "api/config/homepage/",
  API_PROFILE = "api/profile/",
  API_RESET_PASSWORD = "api/forgot/",
  API_SEARCH = "api/search/",
  API_SEARCH_EXPORT = "api/searchExport/",
  API_SESSION = "api/session/",
  API_TOGGLE_HIDE_PAY_WALLED_PROFILES_PREFERENCE = "api/toggleHidePayWalledProfilesPreference/",
  API_TRIAL_SIGNUP = "api/trialSignup/",
  API_USER_CONTACT = "api/userContact/",
  API_USER_MANAGEMENT = "api/userManagement/",
  LOGIN = "login/",
  LOGOUT = "logout/",
}
